import reducer, {
  initialState,
} from './reducer';
import * as actionTypes from './types';
import * as actions from './actions';

// Types
export type {
  $Reducer,
  $State,
} from './reducer';

export type $ActionTypes = typeof actionTypes[keyof typeof actionTypes];

export {
  actions,
  actionTypes,
  initialState,
};

export default reducer;
